import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { SkillDocumentResponse } from '../../../models/skill-learning.model';

type SkillDocumentInput = SkillDocumentResponse | null;

@Component({
  selector: 'app-practice-requirements',
  templateUrl: './practice-requirements.component.html',
  styleUrls: ['./practice-requirements.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PracticeRequirementsComponent {
  @Input() document: SkillDocumentInput = null;
  @Input() hasDocument: boolean = false;

  @Output() downloadClicked = new EventEmitter<void>();

  onDownload(): void {
    if (this.hasDocument) {
      this.downloadClicked.emit();
    }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/user/practice-level/practice-requirements.component.ts